module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "left-div"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChange === 'yes'),
      expression: "isChange==='yes'"
    }],
    staticClass: "QR-code"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/header/QR_code.png")
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChange === 'no'),
      expression: "isChange==='no'"
    }],
    staticClass: "go-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/header/go_back.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v(_vm._s(_vm.titleName))]), _vm._v(" "), _c('msg-window', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msgWindow),
      expression: "msgWindow"
    }],
    attrs: {
      "message": "确定要离开此页吗",
      "btnLeft": "离开此页",
      "btnRight": "留在此页"
    },
    on: {
      "btnClick": _vm.goOthers
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "right-div"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isChange === 'yes'),
      expression: "isChange==='yes'"
    }],
    staticClass: "telephone"
  }, [_c('a', {
    attrs: {
      "href": _vm.setTel
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/header/telephone.png")
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-786b4042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 236
// module chunks = 46